import { useEffect, useState } from "react";
import { Container } from "@mantine/core";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppName } from "../../lib/data";
import "./styles.scss";

const navLinks = [
  { label: "Announcements", href: "/announcements" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Features", href: "/#features" },
  { label: "FAQ", href: "/#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Prevent body scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith("/#")) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          document
            .querySelector(`.${href.replace("/#", "")}-section`)
            ?.scrollIntoView({ behavior: "smooth" });
        }, 300);
      } else {
        document
          .querySelector(`.${href.replace("/#", "")}-section`)
          ?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <nav className={`site-navbar ${scrolled ? "scrolled" : ""}`}>
        <Container size="xl" className="navbar-inner">
          <a
            className="navbar-brand"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
          >
            <img src="/icon.png" alt={AppName} className="navbar-logo-img" />
            <span className="navbar-logo-text">{AppName}</span>
          </a>

          <div className="navbar-links-desktop">
            {navLinks.map((link) => (
              <button
                key={link.label}
                className="navbar-link"
                onClick={() => handleNavClick(link.href)}
              >
                {link.label}
              </button>
            ))}
          </div>

          <div className="navbar-actions">
            <button
              className="navbar-cta"
              onClick={() => navigate("/download")}
            >
              Download App
            </button>

            <button
              className="navbar-hamburger"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <IconX size={24} /> : <IconMenu2 size={24} />}
            </button>
          </div>
        </Container>
      </nav>

      {/* Mobile overlay */}
      <div
        className={`mobile-nav-overlay ${mobileOpen ? "open" : ""}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Mobile drawer */}
      <div className={`mobile-nav-drawer ${mobileOpen ? "open" : ""}`}>
        <div className="mobile-nav-header">
          <div className="navbar-brand">
            <img src="/icon.png" alt={AppName} className="navbar-logo-img" />
            <span className="navbar-logo-text">{AppName}</span>
          </div>
          <button
            className="mobile-close-btn"
            onClick={() => setMobileOpen(false)}
          >
            <IconX size={22} />
          </button>
        </div>

        <div className="mobile-nav-links">
          {navLinks.map((link) => (
            <button
              key={link.label}
              className="mobile-nav-link"
              onClick={() => handleNavClick(link.href)}
            >
              {link.label}
            </button>
          ))}
        </div>

        <button
          className="mobile-nav-cta"
          onClick={() => {
            setMobileOpen(false);
            navigate("/download");
          }}
        >
          Download App
        </button>
      </div>
    </>
  );
}
